export default __webpack_public_path__ + "static/resize-88e19b68e0edd25e512710e3b1d946c0.png";